import type { BaseResponse } from "@marketplace/shared/types";
import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";

import type { CreateAutomationRequestDto } from "../../dtos/create-automation-request-dto";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseUpdateAutomationMutationParams = {
  options?: UseMutationOptions<
    BaseResponse<undefined>,
    unknown,
    { id: string; payload: CreateAutomationRequestDto }
  >;
};

export const useUpdateAutomationMutation = ({
  options
}: UseUpdateAutomationMutationParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }) =>
      await AutomationService.updateAutomation({ id, payload }),
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: AutomationQueryKeys.getAutomationList._def
      });

      options?.onSuccess?.(...args);
    },
    ...options
  });
};
